import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  Isstatus: "All",
  page: 1,

  state: {
    locationList: [],
    searchValue: "",
    selectFilter: [],
  },

  district: {
    locationList: [],
    searchValue: "",
    selectFilter: [],
  },

  city: {
    locationList: [],
    searchValue: "",
    selectFilter: [],
  },
  selectDesignation: "",
  selectWarehouseId: "",
};

const managersSlice = createSlice({
  name: "delivery",
  initialState,
  reducers: {
    setIsstatus: (state, action) => {
      state.Isstatus = action.payload;
    },

    setPage: (state, action) => {
      state.page = action.payload;
    },

    setStateData: (state, action) => {
      state.state = { ...state.state, ...action.payload };
    },

    setDistrictData: (state, action) => {
      state.district = { ...state.district, ...action.payload };
    },

    setCityData: (state, action) => {
      state.city = { ...state.city, ...action.payload };
    },

    setSelectDesignation: (state, action) => {
      state.selectDesignation = action.payload;
    },
    setSelectWarehouseId: (state, action) => {
      state.selectWarehouseId = action.payload;
    },

    resetAllFilters: (state) => {
      state.Isstatus = initialState.Isstatus;
      state.page = initialState.page;
      state.city = initialState.city;
      state.district = initialState.district;
      state.state = initialState.state;
      state.selectDesignation = initialState.selectDesignation;
      state.selectWarehouseId = initialState.selectWarehouseId;
    },
  },
});

export const {
  setIsstatus,
  setPage,
  setStateData,
  setDistrictData,
  setCityData,
  setSelectDesignation,
  setSelectWarehouseId,
  resetAllFilters,
} = managersSlice.actions;

export default managersSlice.reducer;
